﻿const defaultState = {
    questions: [],
    wizardFormSubmitFailed: false,
}

export const wizardData = (state = defaultState, action) => {
    switch (action.type) {
        case 'FETCH_WIZARD':
            return { ...state, questions: action.data };
        case 'WIZARD_FORM_SUBMITTED':
            return { ...state, ...action.data };
        case 'WIZARD_FORM_SUBMIT_FAILED':
            return { ...state, wizardFormSubmitFailed: !!action.data };
   
        default:
            return state;
    }
}
